import type { JurisdictionResponse } from "@/lib/types";
import SortButton from "./SortButton";

interface Props {
  sortColumn: string;
  sortDirection: "ascending" | "descending";
  changeSort: (column: string) => void;
  jurisdiction: JurisdictionResponse;
}

export default function DocumentsTableHeadersBridge(props: Props) {
  return (
    <thead>
      <tr>
        <th className="column-icon" />
        <th className="column-document-name" style={{ width: "20%" }}>
          <SortButton
            direction={
              props.sortColumn === "name" ? props.sortDirection : undefined
            }
            onClick={() => props.changeSort("name")}
          >
            Document Name
          </SortButton>
        </th>
        <th className="column-doc-type" style={{ width: "10%" }}>
          <SortButton
            direction={
              props.sortColumn === "type" ? props.sortDirection : undefined
            }
            onClick={() => props.changeSort("type")}
          >
            Doc Type
          </SortButton>
        </th>
        <th className="column-upload-date" style={{ width: "10%" }}>
          <SortButton
            direction={
              props.sortColumn === "uploadDate"
                ? props.sortDirection
                : undefined
            }
            onClick={() => props.changeSort("uploadDate")}
          >
            Upload Date
          </SortButton>
        </th>
        <th className="column-propounding-party" style={{ width: "10%" }}>
          <SortButton
            direction={
              props.sortColumn === "propoundingParty"
                ? props.sortDirection
                : undefined
            }
            onClick={() => props.changeSort("propoundingParty")}
          >
            Propounding Party
          </SortButton>
        </th>
        <th className="column-responding-party" style={{ width: "10%" }}>
          <SortButton
            direction={
              props.sortColumn === "respondingParty"
                ? props.sortDirection
                : undefined
            }
            onClick={() => props.changeSort("respondingParty")}
          >
            Responding Party
          </SortButton>
        </th>
        {!!props.jurisdiction?.supportsDueDates && (
          <>
            <th className="column-due-date" style={{ width: "10%" }}>
              <SortButton
                direction={
                  props.sortColumn === "realDueDate"
                    ? props.sortDirection
                    : undefined
                }
                onClick={() => props.changeSort("realDueDate")}
              >
                Due Date
              </SortButton>
            </th>
            <th className="column-due-soon" />
          </>
        )}
        <th className="column-client" style={{ width: "10%" }}>
          <SortButton
            direction={
              props.sortColumn === "client" ? props.sortDirection : undefined
            }
            onClick={() => props.changeSort("client")}
          >
            Client
          </SortButton>
        </th>
        <th className="column-client-activity" style={{ width: "15%" }}>
          Client Activity
        </th>
        <th className="column-action" style={{ width: "5%" }} />
        <th className="column-kebab" />
      </tr>
    </thead>
  );
}
